webpackJsonp([35783957827783],{

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Connect = function Connect(_ref) {
	  var pic = _ref.pic,
	      image = _ref.image;
	  return _react2.default.createElement(
	    "div",
	    { className: "col-xs-12 col-sm-4 socMedia " },
	    _react2.default.createElement(
	      "a",
	      { href: pic },
	      _react2.default.createElement("img", { className: "codeLogo logoGrow ", src: image, alt: "Social Media" })
	    )
	  );
	};
	
	exports.default = Connect;
	module.exports = exports["default"];

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IntroShow = function (_Component) {
	  _inherits(IntroShow, _Component);
	
	  function IntroShow() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IntroShow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      adjectives: ['Foodie', 'Developer', 'Veteran'],
	      currentWord: '',
	      wordInterval: 0,
	      intervalClear: ''
	    }, _this.wordTimer = function () {
	      _this.state.wordInterval === 3 ? _this.setState({
	        wordInterval: 1,
	        currentWord: _this.state.adjectives[0]
	      }) : _this.setState({
	        wordInterval: _this.state.wordInterval + 1,
	        currentWord: _this.state.adjectives[_this.state.wordInterval]
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  IntroShow.prototype.componentDidMount = function componentDidMount() {
	    var wordInterval = setInterval(this.wordTimer, 1000);
	    this.setState({ intervalClear: wordInterval });
	  };
	
	  IntroShow.prototype.componentWillUnmount = function componentWillUnmount() {
	    // use intervalId from the state to clear the interval
	    clearInterval(this.state.intervalClear);
	  };
	
	  IntroShow.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'wordShow' },
	        this.state.currentWord
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row justify-content-sm-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 text-center ' },
	          _react2.default.createElement('i', { className: 'fa fa-angle-down glyph ' })
	        )
	      )
	    );
	  };
	
	  return IntroShow;
	}(_react.Component);
	
	exports.default = IntroShow;
	module.exports = exports['default'];

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Project = function Project(_ref) {
	  var image = _ref.image,
	      link = _ref.link,
	      tech = _ref.tech;
	  return _react2.default.createElement(
	    "div",
	    { className: "col-lg-6  appCard " },
	    _react2.default.createElement(
	      "div",
	      { className: "cardWrapper text-center" },
	      _react2.default.createElement("img", { className: "img-fluid cardImage ", src: image }),
	      _react2.default.createElement(
	        "h4",
	        { className: "projCaption" },
	        tech.map(function (eachTech, i) {
	          return i < tech.length - 1 ? eachTech + " | " : eachTech + " ";
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: link },
	          _react2.default.createElement(
	            "button",
	            { className: "btn btn-primary btn-md " },
	            "Preview App"
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Project;
	module.exports = exports["default"];

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/BallinApp.c2003468.png";

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Codepen.8fa458e5.png";

/***/ }),

/***/ 444:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAABG2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS41LjAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+Gkqr6gAAAYJpQ0NQc1JHQiBJRUM2MTk2Ni0yLjEAACiRdZG7SwNBEIe/JEqCRqJoYWERJFoZ8QFRG8EEiUKQECP4apLLS8jjuIuI2Aq2AQXRxlehf4G2grUgKIoggp21oo3KOZcIETGzzM63v90ZdmfBGs0qOb2uD3L5ohYJ+t2zc/Nu+xNO7LTgYCim6OpYOByipr3fYjHjtdesVfvcv9aYSOoKWBzCo4qqFYUnhEMrRdXkLeE2JRNLCJ8I92hyQeEbU49X+NnkdIU/TdaikQBYm4Xd6V8c/8VKRssJy8vx5LLLys99zJc4k/mZaYmd4h3oRAjix80k4wTw0c+IzD68DNArK2rk95XzpyhIriKzyioaS6TJUKRH1GWpnpSYEj0pI8uq2f+/fdVTgwOV6k4/1D8axmsX2Dfhq2QYHweG8XUItgc4z1fzC/sw/CZ6qap59sC1DqcXVS2+DWcb0H6vxrRYWbKJW1MpeDmGpjlovYKGhUrPfvY5uoPomnzVJezsQrecdy1+A0ZQZ9eL5KdFAAAACXBIWXMAAAsTAAALEwEAmpwYAAARiklEQVR4nO2deZAc1X3HP7tarZBeI2RJ3S2EgwUSsgDLwRAEOIBkEHagrBhHcYVUJQ5OiJ2YEJNQDjmKwtiOjR0SU67EXCZHYQxVJrZxgoO5omASG2NA4kZCJxZSd+tAR4+k1R754/tGGo1mZntmXs/O7s6namql3dl+Pfvr997ver8fdOjQoUOHDh06dHBO10jfgAtCP+gCeoBeYKL9dw8wwb66OfqzDgGD9jUA9NvXQfvqi5J4qBX3nyejUsChH/QAxwOz7Su0/z8B8O3rHcCxgAdMRoIv/bz9wH5gr33tBLYBCfCWfUXAlpL/7x9tQh81Ag79wACnAPPt17nAScAcJNxJjoc8iIS9EdgArAXW2NerURK/7Xi8XGhrAYd+MAkJ8yzgDOBUYB7wLrQEt5IBNJvXAq8DLwDPAauiJC60+F4y05YCDv1gBnAOsBh4H5q1s9Ey2y5EaDa/BDwJPBUl8Zsje0tH0zYCtopSAHwQ+BDwy2j5NbTRfVagD9gEvAL8N/AQ8Ea77NVt8YcL/WA68OvAcmAhMAv3e2re9CMl7VXgYeABYP1IC3pEBRz6QS+arX+MZqxPey3DjTCANPLXgHuBB6Ik3jZSNzNiAg79YB5wI3AJMJ3RL9hyBoBdwE+Bf0B79IFW38SEVg8Y+kGPZ8zVwL8AZwNTR+I+WkA3sr9PApYB0zxjVqaFtKUad0tncOgHc4E7gQtpvZkz0gwiRewPgGdatTe3ZOaEftDrGfNbwLfQXjsWZ+xwFK2EjwMHPGOeSwtpfysGzY3QD7qR4nQdcBVyH3YQ3wX+DNgcJfFAXoPkNpNCP5gInA58CfgdtNd2OMy7gSXAy54xcV6zORcBh34wGTgP+DxwGXBMHuOMcrqQvX8B8KZnzC/SQupcy3Yu4NAPPGApcANyNY43ZaoeupCJeA6wyzNmfVpI97kcwKmAQz84Fvg14HrgXGQqdKhNFzANefD2ecasSwtp6urizgRsw3lF4S6iTdygo4hpKFq23zPmDVf2shMB2z13KYeF26ExpqE4d+oZs9bFct20gK22fC5yO55LZ+Y2y3TgZGCbFXJfMxdrSsDWzj0N+CLyTnX2XDfMQEkNmzxjNqSFtGE7uSkBe8bMBL6C9t6OtuyOotfrBOAVz5i30kLakGuzYQHbxLcbkRNjtMVuRwPdKNfsOOD5tJDubOQiDQvYM+YKZOse2+AldgPrUUZjMd11LHGAw1mZIGdPvfpJD4pG7fWMebERpashhchGhZ5EeVKN8gngcXsPk1Fy3WKkjb+H0bfkD6LUnUeBFShXa5f9/q+gmPCcBq+9Df29fhQl8cF6frFuAdul+WHgokZ+3/I2cEJpNqK97kSUx3wWcCXKz2r3AMUBFNS/G3gMrUx9QH8xJBj6wTHob3YBjSuiK4HLoyTeWM8v1b1E22D9Jxv53RIejJL4vtJvpIV0MC2k/WkhLXjGrAW+B/wQLW0n037+7EGUZPeHyIpYFSXxnrSQHrSf5dAb00La7xkzDziTxvWVEBjyjHkqLaSZZ3FdMzD0g/nAE0i7a4ZPR0l8W8Yxu5B9fQOaAbWyLAdLXkMlXyn5WqSr5GsXh4+3dFP5qEuRPpQu+5fAQ1kD96EffBS4HWnHjdKHUpx+nHXczPucTZC7AcV3m+WZrG+0H+QnoR98BPht9Ic9GS3nB0pee4F1KCl9PVJutqLTCXuAffZ9Q0ipm4welhlIW50FnIjCePOQw6EXzbhJ6GHZBvwT8LUoietVeF6099AMvcDNSMiZ/NWZZ3DoB8uAO9Afoxn2A36UxHsb+eXQD94J3IQE8XPgZ8CzwAZXSW3WO3c8yj5ZhHLHdgFfBVY2EqAP/WAC2kdPp3lv36eAu7LM4kwD2bzle9CT06w5swFY0Iww7LJNq/Ka7HhdURIPNnmdx5Gl0KyL+BfA2VESbx3ujcNqdPbDLUNPswtbdTtH74d1ESXxUCsTyu14TQnXsh0t9c3yTuBT1lVckywqewh8lOaUg1Kacp6Pclx+9iuRv7omWQS8FHezF8ZnRmURl86bE1CGZk1qCtie8vsgzStWpUxn/IYU34G7iFsPsDz0g5om63CDnYPO5boMJsym/ZwWuWPNzONxJ+AutEQvq/WmqoPZw9cXIGe3S6agrIXxxi+h1GGXq9cU4PLQD6ZUe0Otp+kUdPjaOLyhIktyuGa7cxYSiEt6gAXUSJOqJeD3IWdCHvvlh3O4ZruzmHwmy3SUcFGRigK26a9n0LzPuRr/mdN125n/IaN7sU4McF7oBzMr/bDaDJ6Lcq3yCML/s32NN/4D+bGdJrYjGc5GMeeKP6zEPLQHu+Yl4AujpQSRS2xw4hbg/2jSk1eBGSjidhRHCdgG3oulilwyCPwV8qOOS6IkToGrUVTLJccBZ1hT7AgqzeDj0ex1nTJzH/CzKIlzPxPbzkRJ/Dpwq+PLdqNw54JKPyhnFu5t3z2oZMN2x9cdrdwC7HB8zRnI6jmCajPYtYAfBtbkedB5NBEl8Xbg3xxfdjrDzeCSYmQufc8HgR+hzIoOh/kWbvfiqcC7ykOI5TO4B6ncLn3PG4CXG0hxGeu8Crzs8Ho9aHJ6pd8sF/BEFEx2yUo6s7cSAygr0yXTkEZ9iEoCdhXYL/IaqvzW4UgGgKcdX3Mqw8zgCbjJmiwyhOot73F4zbHCIFqmXaTwFPEo83dX2oNdniRIgZ31HrcYD9icsp3oJIQrDGURq0oz2GW5oz0oTbZDZfpxaw8fQ1kyRbmAuylbw5tkH+M7yW44BlHCvismoeT4Q1QS8GSHA7ZFUew2x+XfqJdhBNyF2xBhL+M7i3I4unDrcyi2EDpEJVelywyOSYy+c76tpBv3WR5HyC/voinF5lQdqnNUiM8leQt4Km739LFGD4oC5Ua5gIeQh8UVPcBMe8K9Qwk2sDMbt1tY8Wz0ISoJ2HXJ+RD36aJjgW4ar9lRjT4UvTtikFIGcC/g2eSTLjra6cb9AYA+yvwO5QIeRAedXXIKinJ0OJJulAzvkn2UeQ7LBdyP+8jPfGBG8dB2h0P0UiXVtQkKlK3AlQTsOm8qRHtNpxrekcxB55VckpJBwJHjQYtVctq93lWruRT3ZuouykKz5QMcRI2QXbMYCDvLtLBFXn4zh0vvoiz8WEnAm3EfAZqHTsB1nB5iEaqa4JIBVOap+gy2QegI9zlUPcAVKLVzXGOzHq/BvYtyL7Cp/GBBpT1gK8qEdM05wEWVjleMM85HHVddsxNYXf7NSgLegirFuWYKcC3uk/pGDba3xfWUZT46YjtKcDyCagJeg1ufdJGFwLX2gNt45JNoBrtWNotb6/ACjpJ4P7CWw4WsXdKDyvB9JIdrtzWhHywG/oTGC6jXYg86mntU+k81O2w1FdZzR3jAHaEfuHbTtS2hHywAvozOfOVhKm4Hnq5U/a+WgI+a7g6ZAfxX6Adn5jhGWxD6wSnAN5BplFfywzbgqUo/qCjgKIl3AS8gjTovfODB0A8uGYuadegHPaEfnI0q9F5IfsItAD+Pkjiu9MOqg3rGdKEK5XPyuS9AGR+XAQOeMa97xvSlhdRlpn/LCf2g2zPmOOA30DngReSbORMDt6aFtOKWWkvAO4H3omo7eWq9U4D3o7OtkWfMbivoUZVyawV7LNZSQE2x5+Q8bLFt/N9Wa01bVcC2z4CHZnHFEj1lFLP0tyCjuw89GFkejl7UmPFiZCMe8Izp84w50O4zOvSDCbZB2OnAx1BV/GW0JskhRYXBn6j2hpoaXegHs4GvI7OmlqCGUDn9b6InClTE5Uy0Cswn+4mJIeRJexi1p1mNAiA72qW+hw2aTEcH5U9Gtu2luKnmnpUhZM5eFiXxmmpvGvZmQj+4GvhravdIGkJ9lH6vtO2L1ZIvRn2QLkTxz3qUjV3AKlS2/yVUoafoK98ZJXFLjsXYpMHj0EoWojom70EP8CJGJhTaD9weJfE1td6URcBzUbeQD1BbOAmqO3EX8EaUxIOhH1yOUnYeQX0PrkZ7VCMaZQG5UNeiGf4WUjB22O+/6KoKvJ2hc5EQZyCNfzZq2jEXzdqRTiTcClwaJfHKWm/Ksj+uQ/2L3kttP7KPunPNAu4J/eB/0RL7AjoOsxc9KH+K9tt6l7IpaAk8veR7b6Mztl9AXU1cMhN9niVoe2m3zqrfR3/bmgw7k9JCimfMFpSVcSK1P+gUVMrnNDTjXouSeItnzCzgs0jgz6Dl2sUMGEIf9Nsua4DYz/w22mfPIp/gQDNsRb2nhg3rZloqPWN22/eez/DaYQ9SPhZgmxyjvXQrUpieRlrzkixj12AIKXTXRUns3G+eFtI+z5hNaLXJozBcM9wC/Htpd7VqZBKwfaI3IZt4Xobf60J710lIqGuiJF7tGbMXBbufR8Ve5mQZvwoDwNeAH2b5oI1g73ciI6dIVWIVeqgzlcXIvK9ESbwDddDMeiK9Gykpn+ZwgvcE1L3sE0gzbyb/aw9wX57tdey1H0dKXTs4XvqBL1FHpK8ubdYzZivaO3+VbA9HNzKNNnrGvIISszegwiyP2a8X01iu1grgzrw9Xp4x+5Dmv5CRT/29B/hGPfpGXZqhtTtvRbWvsjIFBbrn2OZST6DOopNQkt+1wJv13Iflx46aVdXEjrEKt8VSGmEtWkHrKsVct+ofJfFO1FK1nuIqC4CloR94URIftEkF56PC4BcBlwMPoiUoC+uQbd0q1uG+kHc99AE3Aq/XuyU1ZNtZ4/qzdY7zcY48C7sCzeSBKImfQ1mXH0DhtTc48pTcbtSI8u9RjvX8KImfbeTeG2QL7ms818NtwCON9Htsxni/HbiX7IW8zgCWFGO/URLvj5L496Mkvsq28LkEPTQ/Qc6MachjNAcIoyQ+G7gfOfKXNnHfjbCX7KuLSwaRkndHFpu3Eg0L2Dr+/wK1N88q5OuBE6uccJiAghLvRw6GAPg88ChwoU3U+yOkhbe6a8s+3Faky8IQyqr5Ck2kTzXrftsKfAa5C7PsDacCn0MO+0PYpecH6LTdn9u2qfuQK24FCjAMoubQy1GstZWUdhJvBUNI8fwq8FQzdbabDm3Z5fVDyLuStZHHPyInxfpWtoltFNtmaAWKHrWCrUhj/qZVahum6TyhtJAOeMZsRolfC8l2PGUR8mQlnjG700La1rWkbeLDlSiQkjcxisjd3ei+W4qTRDDrt92ItN13k61yzKlY37ZnzATPmAHPmH1pIR12OQr9YLJnzEBeLspyPGOmAr9L/gKOUcj1tiiJN7u4oNPsA9sK/goUEjyqQUQVDqKTFD9FwYPNyB2aIvtvCAUnpqAkvWLQ/e+sPZ07oR+EqC2B6xOBpcTAv6IgvrOjQ04jJFES7wj94H4ktGuQuTOcIjcRhRdPQwJNOHwM8gAS8CQUxZqGhGtQrvFYqGRbPHZyF8qvasSrVxXnITAr5O8g2/EzKJ6adZxe1C8xS8/EsVB7q6gtfx2411oPTsklS8G2rvsBMokeJ5+Z1k7x2UYo2rl/gxSqXA4Z5JaGYtu4PYE+wLcZeWd9u/EYOoz2QJ69HHPNM7LRp+eBm4AvIp9u29u9ObMf2bjXACvyVhRzX+ZsuG1T6Ad3As+iBLnzaF3+cDuxGkWFHouSeFsrBmxZpqA90PYkqi5zE2NDA85KH3A3Oq/0vVYJF1qcCholcb9NkLsZBRUebeX4I8SzyDdwHfBKIyG/ZhgRTdR+yOdDP/gweqo/R3bHyGhhM7LV746S2HVxucyMqKlhlbD7Qz94FCXiXYXONPUy/OrisjuMC4aQgycCvouC9KtHOpjSFrakbbd6S+gH96Hl7GMoMuVRuZ5UH63tRXyAw161cuVwADl13gIeQr7kl0dasEXaUpMN/cBHGR7LUYRqJvJDdyMf9SNREi9v8T3djCJKPvq7pegh24hOV3zfpQ/ZFW0p4CK2puNclAgwH7kn1wPfaaUmau9lKkoXWogetPXoGM5LrQp6dOjQoUOHDh1GD/8PvtUpTpGV4cYAAAAASUVORK5CYII="

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/brad.bdacb7ce.png";

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/homeApp.eb245d26.png";

/***/ }),

/***/ 447:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(63);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _IntroShow = __webpack_require__(198);
	
	var _IntroShow2 = _interopRequireDefault(_IntroShow);
	
	var _Project = __webpack_require__(200);
	
	var _Project2 = _interopRequireDefault(_Project);
	
	var _Connect = __webpack_require__(197);
	
	var _Connect2 = _interopRequireDefault(_Connect);
	
	var _brad = __webpack_require__(445);
	
	var _brad2 = _interopRequireDefault(_brad);
	
	var _Codepen = __webpack_require__(443);
	
	var _Codepen2 = _interopRequireDefault(_Codepen);
	
	var _GitHub = __webpack_require__(444);
	
	var _GitHub2 = _interopRequireDefault(_GitHub);
	
	var _homeApp = __webpack_require__(446);
	
	var _homeApp2 = _interopRequireDefault(_homeApp);
	
	var _linkedInLogo = __webpack_require__(447);
	
	var _linkedInLogo2 = _interopRequireDefault(_linkedInLogo);
	
	var _BallinApp = __webpack_require__(441);
	
	var _BallinApp2 = _interopRequireDefault(_BallinApp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'jumbotronFade' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row justify-content-sm-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-auto' },
	            _react2.default.createElement('img', { src: _brad2.default, className: 'myPic img-fluid' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row justify-content-sm-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'intro' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'Hi, my name is '
	              ),
	              _react2.default.createElement(
	                'h1',
	                null,
	                'Brad '
	              ),
	              _react2.default.createElement(
	                'h1',
	                null,
	                ' and I am a'
	              )
	            ),
	            _react2.default.createElement(_IntroShow2.default, null)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container-fluid' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col align-self-center' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'myWork' },
	            'My Work'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row ' },
	        _react2.default.createElement(_Project2.default, {
	          image: _BallinApp2.default,
	          link: 'https://still-inlet-76133.herokuapp.com/',
	          tech: ['Node', 'Handlebars', 'Express', 'Passport']
	        }),
	        _react2.default.createElement(_Project2.default, {
	          image: _homeApp2.default,
	          link: 'https://myhome-app.herokuapp.com/login',
	          tech: ['React', 'MongoDB', 'Meteor.js', 'Bootstrap']
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row socLink' },
	        _react2.default.createElement(_Connect2.default, { pic: 'https://codepen.io/bhank/', image: _Codepen2.default }),
	        _react2.default.createElement(_Connect2.default, { pic: 'https://github.com/bhankee', image: _GitHub2.default }),
	        _react2.default.createElement(_Connect2.default, {
	          pic: 'ttps://www.linkedin.com/in/brad-hankee',
	          image: _linkedInLogo2.default
	        })
	      )
	    ),
	    _react2.default.createElement('div', { className: 'container-fluid' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container-fluid' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row bottomFooter' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-6 col-md-6 footer' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Copyright \xA9 Brad Hankee 2018'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-6 col-md-6 footer' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'footer' },
	            _react2.default.createElement(
	              'li',
	              null,
	              'Made with',
	              _react2.default.createElement('span', { className: 'fa fa-coffee' }),
	              'by Brad Hankee'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-2590aae93bac178fbf63.js